export const cmsApiUrl = 'https://lendwithcare.cdn.prismic.io/api/v2'

/**
 * User permissions to check when rendering navigation and before performing actions.
 * @type {{}}
 */
export const permissions = {
  ho: 'ho-content',
}
